import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RfqSettingService {

  constructor(
    private http: HttpClient
  ) { }


  searchRfqSetting(form: any):Observable<any>{
    const url = `${environment.expenseApiUrl}/rfqSetting/searchRFQSetting`;
    return this.http.post(url, form);
  }


  async getRfqDetail(seqNo: number){
    const url = `${environment.expenseApiUrl}/rfqSetting/getRfqDetail/${seqNo}`;
    return await this.http.get(url).toPromise();
  }

  async getRfq(seqNo: number){
    const url = `${environment.expenseApiUrl}/rfqSetting/getRfq/${seqNo}`;
    return await this.http.get(url).toPromise();
  }

  updateStatus(form: any):Observable<any>{
    const url = `${environment.expenseApiUrl}/rfqSetting/updataStatus`;
    return this.http.post(url, form);
  }

  getRFQExcel(form: any):Observable<any>{
    const url = `${environment.expenseApiUrl}/rfqSetting/getRFQExcel`;
    return this.http.post(url, form, {responseType: 'blob'});
  }

  deleteRFQ(seqNo: Number): Observable<any>{
    const url = `${environment.expenseApiUrl}/rfqSetting/deleteRFQ/${seqNo}`;
    return this.http.delete(url);
  }


  uploadFile(file: any, facility: string, forwarder: string, createUser : string): Observable<any>{

    let url = `${environment.expenseApiUrl}/import/rfqExcelBy`;

    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('facility', facility);
    formData.append('createUser', createUser);
    formData.append('forwarder', forwarder);

    let response = this.http.post(url, formData ,  {
      reportProgress: true,
      responseType: 'json'
    } );
    return response;
  }

  preview(file: any, forwarder: string , createUser : string): Observable<any>{

    let url = `${environment.expenseApiUrl}/import/rfqExcelPreview`;

    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('createUser', createUser);
    formData.append('forwarder', forwarder);

    let response = this.http.post(url, formData ,  {
      reportProgress: true,
      responseType: 'json'
    } );
    return response;
  }


  updateRfq(rfqForm: any):Observable<any>{
    const url = `${environment.expenseApiUrl}/rfqSetting/updateRfq`;
    return this.http.post(url, rfqForm);
  }

  deleteRfqDetail(seqNo: number){
    const url = `${environment.expenseApiUrl}/rfqSetting/deleteRfqDetail/${seqNo}`;
    return this.http.delete(url);
  }


}
